<template>
    <div>
        <label :for="id" v-if="!!label">{{ label }}</label>
        <b-form-file v-bind="$attrs" v-on="$listeners" :id="id" browse-text="Buscar archivo"></b-form-file>
    </div>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        label: {
            type: String,
        },
        id: {
            type: String,
            default: () => `file-${Math.round(Math.random() * 100000000)}`,
        },
    },
    data: () => ({
        //
    }),
    methods: {
        //
    },
}
</script>
